import './Styles/global.css';
import Header from './Components/Header.js'
import MobileNav from './Components/MobileNav'
import Footer from './Components/Footer'
import React, { useState } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom"
import Home from './Pages/Home'
import Profile from './Pages/Profile'
import LoginForm from './Components/LoginForm';
import RegisterForm from './Components/RegisterForm';
import ResetForm from './Components/ResetForm';
import Dashboard from './Components/Dashboard';
import EditProfileScreen from './Components/EditProfileScreen';
import EditEventScreen from './Components/EditEventScreen';
import EventScreen from './Components/EventScreen';
import EditServiceScreen from './Components/EditServiceScreen';
import EditArtistScreen from './Components/EditArtistScreen';
import EditVenuePage from './Pages/EditVenuePage';
import VenueScreen from './Components/VenueScreen';
import MessagesScreen from './Components/MessagesScreen';
import ArtistPage from './Pages/ArtistPage';
import BrowsePage from './Pages/BrowsePage';
import ArtistsTab from './Components/ArtistsTab';
import RegvenuesTab from './Components/RegvenuesTab.js';
import SearchservicesTab from './Components/SearchservicesTab';
import SearchvenuesTab from './Components/SearchvenuesTab';

function App() {
  const [pageName, setPageName] = useState("Home")
  const [isMobNavOpen, setIsMobNavOpen] = useState(false)
  return (
    <Router>
      <MobileNav pageName={pageName} isMobNavOpen={isMobNavOpen} setIsMobNavOpen={setIsMobNavOpen} />
      <div id="container"
        style={{
          position: `absolute`,
          width: `100%`,
          left: `${isMobNavOpen ? '-250px' : 0}`,
          transition: `500ms ease`
        }}
        onClick={() => {
          if (isMobNavOpen) { setIsMobNavOpen(false) }
        }}>
        <Header pageName={pageName} isMobNavOpen={isMobNavOpen} setIsMobNavOpen={setIsMobNavOpen} />
        <main>
          <Routes>
            <Route exact path="/" element={<Home setPageName={setPageName} />} />
            <Route path="/edit_event/:eventId" element={<EditEventScreen setPageName={setPageName} />} />
            <Route path="/event/:eventId" element={<EventScreen setPageName={setPageName} />} />
            <Route path="/edit_service/:serviceId&:priceId" element={<EditServiceScreen setPageName={setPageName} />} />
            <Route path="/edit_artist/" element={<EditArtistScreen setPageName={setPageName} />} />
            <Route path="/venue/:venueId&:docId" element={<VenueScreen setPageName={setPageName} />} />
            <Route path="/artist/:artuid&:type" element={<ArtistPage setPageName={setPageName} />} />
            <Route path="/edit_venue/:venueId" element={<EditVenuePage setPageName={setPageName} />} />
            <Route path="/messages/:locUid%26:conversationID%26:locName" element={<MessagesScreen setPageName={setPageName} />} />
            <Route path="/browse" element={<BrowsePage setPageName={setPageName} />} >
              <Route path="artists" element={<ArtistsTab />} />
              <Route path="venues" element={<RegvenuesTab />} />
              <Route path="artists-search" element={<SearchservicesTab />} />
              <Route path="venues-search" element={<SearchvenuesTab />} />
            </Route>
            <Route path="/Profile" element={<Profile setPageName={setPageName} />}>
              <Route path="login" element={<LoginForm />} />
              <Route path="register" element={<RegisterForm />} />
              <Route path="reset_password" element={<ResetForm />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="edit" element={<EditProfileScreen />} />
            </Route>
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;